export const ContactFormStyles: Record<string, any> = {
  wrapperStyles:
    'flex flex-col w-full lg:w-1/2 px-5 pt-10 md:pt-20 md:pb-40 justify-center m-auto',
  fillWhite: 'fill-white',
  headlineWrapper: 'pb-4',
  commonWrapperStyle: 'pt-4',
  emailPhoneWrapper: 'md:justify-between md:flex md:flex-row md:pt-4',
  emailWrapper: 'pt-4 w-full md:pt-0 md:w-[48%]',
  phoneWrapper: 'pt-4 w-full md:pt-0 md:w-[48%]',
  selectBoxStyle: 'border-machine2-75 w-full',
  buttonWrapper: 'py-4'
}
